import { useWeb3React } from "@web3-react/core";
import React, { useCallback, useEffect, useState } from "react";
import { callGraphQLQuery } from "../../utils/axiosClient";
import Web3 from "web3";
import { Modal } from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
const Playtable = ({ randomNumber, betHistory }) => {
  const [key, setKey] = useState("winners");
  let { account } = useWeb3React();
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = useCallback(() => setShow(false), []);
  const [winner, setWinner] = useState([]);
  const [loser, setLoser] = useState([]);

  const fetchTopWinner = async () => {
    const query = `
      query CrashBetResolved {
       betResolveds(
    where: {won: true}
    first: 10
    orderDirection: desc
    orderBy: payout
  ){
  won
  player
  payout
  amount
  odds
  transactionHash
  blockTimestamp
}
      }
    `;

    try {
      const data = await callGraphQLQuery(query);
      setWinner(data.betResolveds);
    } catch (error) {
      console.error("Failed to fetch bet history:", error);
    }
  };

  const fetchTopLoser = async () => {
    const query = `
      query CrashBetResolved {
       betResolveds(
    where: {won: false}
    first: 10
    orderDirection: desc
    orderBy: amount
  ){
  won
  player
  payout
  amount
  odds
  transactionHash
  blockTimestamp
}
      }
    `;

    try {
      const data = await callGraphQLQuery(query);

      setLoser(data.betResolveds);
    } catch (error) {
      console.error("Failed to fetch bet history:", error);
    }
  };

  useEffect(() => {
    fetchTopWinner();
    fetchTopLoser();
  }, []);

  function shortenAddress(address, chars = 4) {
    if (!address) return "";
    return `${address.slice(0, 2 + chars)}...${address.slice(-chars)}`;
  }

  function formatTimestamp(unixSeconds) {
    const date = new Date(unixSeconds * 1000); // Convert to milliseconds

    const options = {
      day: "2-digit",
      month: "short", // You can use 'long' for full month names
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false, // Set to true if you want 12-hour format
    };

    return date.toLocaleString("en-GB", options).replace(",", "");
  }
  return (
    <>
      <section className="maininnerlower">
        <div className="playtable">
          <h6 className="playhead">My Bet History</h6>
          <div className="maintable">
            <div className="innertable">
              <table>
                <thead>
                  <tr>
                    <th>Date & Time</th>
                    <th>Tx Hash</th>
                    <th>Bet Amount</th>
                    <th>Odds</th>
                    <th>Result</th>
                    <th>Payout</th>
                  </tr>
                </thead>

                <tbody>
                  {account ? (
                    betHistory && betHistory.length > 0 ? (
                      betHistory.map((bet) => (
                        <tr>
                          <td>
                            <p className="datepara">
                              {formatTimestamp(bet.blockTimestamp)}
                            </p>
                          </td>
                          <td>
                            <div className="mainlink">
                              <a
                                href={`https://basescan.org/tx/${bet.transactionHash}`}
                                className="innerlink"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {shortenAddress(bet.transactionHash)}
                              </a>
                              <a
                                href={`https://basescan.org/tx/${bet.transactionHash}`}
                                className="innerlink"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="13"
                                  height="12"
                                  viewBox="0 0 13 12"
                                  fill="none"
                                >
                                  <path
                                    d="M11.1667 6.5V9.5C11.1667 9.76522 11.0614 10.0196 10.8739 10.2071C10.6863 10.3946 10.432 10.5 10.1667 10.5H3.16675C2.90153 10.5 2.64718 10.3946 2.45964 10.2071C2.2721 10.0196 2.16675 9.76522 2.16675 9.5V2.5C2.16675 2.23478 2.2721 1.98043 2.45964 1.79289C2.64718 1.60536 2.90153 1.5 3.16675 1.5H6.16675"
                                    stroke="#3E3F43"
                                    stroke-width="1.04"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M11.1667 1.5L6.66675 6"
                                    stroke="#3E3F43"
                                    stroke-width="1.04"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M8.16675 1.5H11.1667V4.5"
                                    stroke="#3E3F43"
                                    stroke-width="1.04"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                              </a>
                            </div>
                          </td>
                          <td>
                            {parseFloat(
                              Web3.utils.fromWei(String(bet?.amount), "mwei")
                            ).toFixed(2)}{" "}
                            USDC
                          </td>
                          <td>{bet.odds}%</td>
                          <td>
                            <p className={bet.won ? "greenpara" : "redpara"}>
                              {bet.won ? "Won" : "Loss"}
                            </p>
                          </td>
                          <td>
                            {(() => {
                              const payout = parseFloat(bet?.payout || 0);
                              const converted = payout / 1e6;
                              return `${converted.toFixed(2)}`;
                            })()}
                            USDC
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={6}>
                          <div className="connectwalletmain w-100">
                            <span className="mainimg">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="38"
                                height="38"
                                viewBox="0 0 38 38"
                                fill="none"
                              >
                                <path
                                  d="M3.16797 3.16699L34.8346 34.8337"
                                  stroke="#F24CA2"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M13.2188 4.25882C16.0856 3.13913 19.2166 2.87923 22.2288 3.51092C25.241 4.14262 28.0038 5.63851 30.1792 7.81563C32.3546 9.99275 33.8484 12.7567 34.4778 15.7694C35.1071 18.7821 34.8448 21.9129 33.7229 24.7788"
                                  stroke="#F24CA2"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M30.2118 30.21C28.7397 31.6821 26.992 32.8498 25.0686 33.6465C23.1452 34.4433 21.0837 34.8533 19.0018 34.8533C16.9199 34.8533 14.8584 34.4433 12.935 33.6465C11.0115 32.8498 9.26389 31.6821 7.79177 30.21C6.31965 28.7379 5.15191 26.9902 4.3552 25.0668C3.5585 23.1434 3.14844 21.0819 3.14844 19C3.14844 16.9181 3.5585 14.8566 4.3552 12.9332C5.15191 11.0098 6.31965 9.2621 7.79177 7.78998"
                                  stroke="#F24CA2"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </span>
                            <h6 className="connecthead">
                              You Haven't Placed Any Bets Yet
                            </h6>
                            <p className="connectpara">
                              Your bets will show up here after you place one.
                            </p>
                          </div>
                        </td>
                      </tr>
                    )
                  ) : (
                    <tr>
                      <td colSpan={6}>
                        <div className="connectwalletmain w-100">
                          <span className="mainimg">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="38"
                              height="38"
                              viewBox="0 0 38 38"
                              fill="none"
                            >
                              <path
                                d="M30.0833 11.0833V6.33333C30.0833 5.91341 29.9165 5.51068 29.6196 5.21375C29.3227 4.91681 28.9199 4.75 28.5 4.75H7.91667C7.07681 4.75 6.27136 5.08363 5.6775 5.6775C5.08363 6.27136 4.75 7.07681 4.75 7.91667C4.75 8.75652 5.08363 9.56197 5.6775 10.1558C6.27136 10.7497 7.07681 11.0833 7.91667 11.0833H31.6667C32.0866 11.0833 32.4893 11.2501 32.7863 11.5471C33.0832 11.844 33.25 12.2467 33.25 12.6667V19M33.25 19H28.5C27.6601 19 26.8547 19.3336 26.2608 19.9275C25.667 20.5214 25.3333 21.3268 25.3333 22.1667C25.3333 23.0065 25.667 23.812 26.2608 24.4058C26.8547 24.9997 27.6601 25.3333 28.5 25.3333H33.25C33.6699 25.3333 34.0727 25.1665 34.3696 24.8696C34.6665 24.5727 34.8333 24.1699 34.8333 23.75V20.5833C34.8333 20.1634 34.6665 19.7607 34.3696 19.4637C34.0727 19.1668 33.6699 19 33.25 19Z"
                                stroke="#F24CA2"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M4.75 7.9165V30.0832C4.75 30.923 5.08363 31.7285 5.6775 32.3223C6.27136 32.9162 7.07681 33.2498 7.91667 33.2498H31.6667C32.0866 33.2498 32.4893 33.083 32.7863 32.7861C33.0832 32.4892 33.25 32.0864 33.25 31.6665V25.3332"
                                stroke="#F24CA2"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </span>
                          <h6 className="connecthead">
                            You Haven't Connected Your Wallet Yet
                          </h6>

                          <p className="connectpara">
                            Click here to connect your wallet.
                          </p>

                          {account ? (
                            <button className="disconnectbtn">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                              >
                                <path
                                  d="M10 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667V3.33333C14 2.97971 13.8595 2.64057 13.6095 2.39052C13.3594 2.14048 13.0203 2 12.6667 2H10"
                                  stroke="#FF3434"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M5.33594 11.3337L2.0026 8.00033L5.33594 4.66699"
                                  stroke="#FF3434"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M2 8H10"
                                  stroke="#FF3434"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                              Disconnect
                            </button>
                          ) : (
                            ""
                          )}
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div className="mainboxes d-none">
            {account ? (
              betHistory && betHistory.length > 0 ? (
                betHistory?.map((bet) => (
                  <div className="mainbox" key={bet?.id}>
                    {" "}
                    {/* Don't forget the key! */}
                    <div className="innerbox">
                      <p className="boxpara">Date & Time</p>
                      <h6 className="boxhead">
                        {formatTimestamp(bet?.blockTimestamp)}
                      </h6>
                    </div>
                    <div className="innerbox">
                      <p className="boxpara">Tx Hash</p>
                      <div className="mainlink">
                        {shortenAddress(bet?.transactionHash)}

                        <a
                          href={`https://basescan.org/tx/${bet?.transactionHash}`}
                          className="innerlink"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="13"
                            height="12"
                            viewBox="0 0 13 12"
                            fill="none"
                          >
                            <path
                              d="M11.1667 6.5V9.5C11.1667 9.76522 11.0614 10.0196 10.8739 10.2071C10.6863 10.3946 10.432 10.5 10.1667 10.5H3.16675C2.90153 10.5 2.64718 10.3946 2.45964 10.2071C2.2721 10.0196 2.16675 9.76522 2.16675 9.5V2.5C2.16675 2.23478 2.2721 1.98043 2.45964 1.79289C2.64718 1.60536 2.90153 1.5 3.16675 1.5H6.16675"
                              stroke="#3E3F43"
                              strokeWidth="1.04" // Corrected: strokeWidth
                              strokeLinecap="round" // Corrected: strokeLinecap
                              strokeLinejoin="round" // Corrected: strokeLinejoin
                            />
                            <path
                              d="M11.1667 1.5L6.66675 6"
                              stroke="#3E3F43"
                              strokeWidth="1.04"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M8.16675 1.5H11.1667V4.5"
                              stroke="#3E3F43"
                              strokeWidth="1.04"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </a>
                      </div>
                    </div>
                    <div className="innerbox">
                      <p className="boxpara">Bet Amount</p>
                      <h6 className="boxhead">
                        $
                        {(() => {
                          const betAmountInEther = parseFloat(
                            Web3?.utils?.fromWei(String(bet?.amount), "ether")
                          );
                          return betAmountInEther.toFixed(2);
                        })()}{" "}
                      </h6>
                    </div>
                    <div className="innerbox">
                      <p className="boxpara">Odds</p>
                      <h6 className="boxhead">{bet?.odds}%</h6>
                    </div>
                    <div className="innerbox">
                      <p className="boxpara">Result</p>
                      <h6 className={bet?.won ? "greenpara" : "redpara"}>
                        {bet?.won ? "Won" : "Loss"}
                      </h6>
                    </div>
                    <div className="innerbox">
                      <p className="boxpara">Payout</p>
                      <h6 className="boxhead">
                        {(() => {
                          const payout = parseFloat(bet?.payout || 0);
                          const converted = payout / 1e6;
                          return `${converted.toFixed(2)} `;
                        })()}
                        USDC
                      </h6>
                    </div>
                  </div>
                ))
              ) : (
                <div className="connectwalletmain w-100">
                  <span className="mainimg">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="38"
                      height="38"
                      viewBox="0 0 38 38"
                      fill="none"
                    >
                      <path
                        d="M3.16797 3.16699L34.8346 34.8337"
                        stroke="#F24CA2"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M13.2188 4.25882C16.0856 3.13913 19.2166 2.87923 22.2288 3.51092C25.241 4.14262 28.0038 5.63851 30.1792 7.81563C32.3546 9.99275 33.8484 12.7567 34.4778 15.7694C35.1071 18.7821 34.8448 21.9129 33.7229 24.7788"
                        stroke="#F24CA2"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M30.2118 30.21C28.7397 31.6821 26.992 32.8498 25.0686 33.6465C23.1452 34.4433 21.0837 34.8533 19.0018 34.8533C16.9199 34.8533 14.8584 34.4433 12.935 33.6465C11.0115 32.8498 9.26389 31.6821 7.79177 30.21C6.31965 28.7379 5.15191 26.9902 4.3552 25.0668C3.5585 23.1434 3.14844 21.0819 3.14844 19C3.14844 16.9181 3.5585 14.8566 4.3552 12.9332C5.15191 11.0098 6.31965 9.2621 7.79177 7.78998"
                        stroke="#F24CA2"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                  <h6 className="connecthead">
                    You Haven't Placed Any Bets Yet
                  </h6>
                  <p className="connectpara">
                    Your bets will show up here after you place one.
                  </p>
                </div>
              )
            ) : (
              // Address does NOT exist
              <div className="connectwalletmain w-100">
                <span className="mainimg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="38"
                    height="38"
                    viewBox="0 0 38 38"
                    fill="none"
                  >
                    <path
                      d="M30.0833 11.0833V6.33333C30.0833 5.91341 29.9165 5.51068 29.6196 5.21375C29.3227 4.91681 28.9199 4.75 28.5 4.75H7.91667C7.07681 4.75 6.27136 5.08363 5.6775 5.6775C5.08363 6.27136 4.75 7.07681 4.75 7.91667C4.75 8.75652 5.08363 9.56197 5.6775 10.1558C6.27136 10.7497 7.07681 11.0833 7.91667 11.0833H31.6667C32.0866 11.0833 32.4893 11.2501 32.7863 11.5471C33.0832 11.844 33.25 12.2467 33.25 12.6667V19M33.25 19H28.5C27.6601 19 26.8547 19.3336 26.2608 19.9275C25.667 20.5214 25.3333 21.3268 25.3333 22.1667C25.3333 23.0065 25.667 23.812 26.2608 24.4058C26.8547 24.9997 27.6601 25.3333 28.5 25.3333H33.25C33.6699 25.3333 34.0727 25.1665 34.3696 24.8696C34.6665 24.5727 34.8333 24.1699 34.8333 23.75V20.5833C34.8333 20.1634 34.6665 19.7607 34.3696 19.4637C34.0727 19.1668 33.6699 19 33.25 19Z"
                      stroke="#F24CA2"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M4.75 7.9165V30.0832C4.75 30.923 5.08363 31.7285 5.6775 32.3223C6.27136 32.9162 7.07681 33.2498 7.91667 33.2498H31.6667C32.0866 33.2498 32.4893 33.083 32.7863 32.7861C33.0832 32.4892 33.25 32.0864 33.25 31.6665V25.3332"
                      stroke="#F24CA2"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                <h6 className="connecthead">
                  You Haven't Connected Your Wallet Yet
                </h6>
              </div>
            )}
          </div>
          {/* <div className="connectwalletmain">
          <span className="mainimg">
            <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none">
  <path d="M30.0833 11.0833V6.33333C30.0833 5.91341 29.9165 5.51068 29.6196 5.21375C29.3227 4.91681 28.9199 4.75 28.5 4.75H7.91667C7.07681 4.75 6.27136 5.08363 5.6775 5.6775C5.08363 6.27136 4.75 7.07681 4.75 7.91667C4.75 8.75652 5.08363 9.56197 5.6775 10.1558C6.27136 10.7497 7.07681 11.0833 7.91667 11.0833H31.6667C32.0866 11.0833 32.4893 11.2501 32.7863 11.5471C33.0832 11.844 33.25 12.2467 33.25 12.6667V19M33.25 19H28.5C27.6601 19 26.8547 19.3336 26.2608 19.9275C25.667 20.5214 25.3333 21.3268 25.3333 22.1667C25.3333 23.0065 25.667 23.812 26.2608 24.4058C26.8547 24.9997 27.6601 25.3333 28.5 25.3333H33.25C33.6699 25.3333 34.0727 25.1665 34.3696 24.8696C34.6665 24.5727 34.8333 24.1699 34.8333 23.75V20.5833C34.8333 20.1634 34.6665 19.7607 34.3696 19.4637C34.0727 19.1668 33.6699 19 33.25 19Z" stroke="#F24CA2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M4.75 7.9165V30.0832C4.75 30.923 5.08363 31.7285 5.6775 32.3223C6.27136 32.9162 7.07681 33.2498 7.91667 33.2498H31.6667C32.0866 33.2498 32.4893 33.083 32.7863 32.7861C33.0832 32.4892 33.25 32.0864 33.25 31.6665V25.3332" stroke="#F24CA2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
          </span>
          <h6 className="connecthead">You Haven’t Connected Your Wallet Yet</h6>
          <p className="connectpara">Click here to connect your wallet.</p>
          <button className="connectbtn">Connect Wallet</button>
        </div> */}
        </div>
        <div className="rightmain">
          <Tabs
            id="controlled-tab-example"
            activeKey={key}
            onSelect={(k) => setKey(k)}
            className="playtabs"
          >
            <Tab eventKey="winners" title="Top 10 WINNERS">
              <div className="bottomhead">
                <p className="mainpara">Wallet Address</p>
                <p className="mainpara">Amount</p>
              </div>
              <div className="bettingdetails">
                {winner?.map((item, index) => {
                  return (
                    <div key={index} className="mainbet">
                      <a
                        href={`https://basescan.org/tx/${item?.transactionHash}`}
                        className="innerlink"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <div className="betleft">
                          <span className="wallet">
                            {shortenAddress(item?.player)}
                          </span>
                          {/* <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_596_636)">
                        <path
                          d="M10 4H5C4.44772 4 4 4.44772 4 5V10C4 10.5523 4.44772 11 5 11H10C10.5523 11 11 10.5523 11 10V5C11 4.44772 10.5523 4 10 4Z"
                          stroke="#3E3F43"
                          stroke-width="1.04"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M2 8C1.45 8 1 7.55 1 7V2C1 1.45 1.45 1 2 1H7C7.55 1 8 1.45 8 2"
                          stroke="#3E3F43"
                          stroke-width="1.04"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_596_636">
                          <rect width="12" height="12" fill="white" />
                        </clipPath>
                      </defs>
                    </svg> */}
                        </div>
                      </a>
                      <p className="greenpara">
                        $
                        {item?.payout
                          ? parseFloat(
                              Web3.utils.fromWei(String(item.payout), "mwei")
                            ).toFixed(2)
                          : "0.00"}
                      </p>
                    </div>
                  );
                })}
              </div>
            </Tab>
            <Tab eventKey="losers" title="Top 10 losers">
              <div className="bottomhead">
                <p className="mainpara">Wallet Address</p>
                <p className="mainpara">Amount</p>
              </div>
              <div className="bettingdetails">
                {loser?.map((item, index) => {
                  return (
                    <div key={index} className="mainbet">
                      <a
                        href={`https://basescan.org/tx/${item?.transactionHash}`}
                        className="innerlink"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <div className="betleft">
                          <span className="wallet">
                            {shortenAddress(item?.player)}
                          </span>
                          {/* <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_596_636)">
                        <path
                          d="M10 4H5C4.44772 4 4 4.44772 4 5V10C4 10.5523 4.44772 11 5 11H10C10.5523 11 11 10.5523 11 10V5C11 4.44772 10.5523 4 10 4Z"
                          stroke="#3E3F43"
                          stroke-width="1.04"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M2 8C1.45 8 1 7.55 1 7V2C1 1.45 1.45 1 2 1H7C7.55 1 8 1.45 8 2"
                          stroke="#3E3F43"
                          stroke-width="1.04"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_596_636">
                          <rect width="12" height="12" fill="white" />
                        </clipPath>
                      </defs>
                    </svg> */}
                        </div>
                      </a>
                      <p className="redpara">
                        $
                        {item?.payout
                          ? parseFloat(
                              Web3.utils.fromWei(String(item.payout), "mwei")
                            ).toFixed(2)
                          : "0.00"}
                      </p>
                    </div>
                  );
                })}
              </div>
            </Tab>
          </Tabs>
        </div>
      </section>
      <Modal className="metamodal" show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Connect Wallet</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parentbox">
            <div onClick={handleClose} className="mainbox d-noneformobile">
              {/* <CustomConnectButton buttonText="Metamask" className=''/> */}
              {/* <WalletButton wallet="metamask" /> */}
            </div>
            <div onClick={handleClose} className="mainbox">
              {/* <CustomConnectButton buttonText="WalletConnect" className=''/> */}
              {/* <WalletButton wallet="walletconnect" /> */}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Playtable;
